<template>
  <div id="video_list">
    <!--列表-->
    <div class="list relativeItem">
      <p class="title" v-if="!share_live">热门视频</p>
      <p class="title" v-else>热门直播</p>

      <!--列表查看更多下载-->
      <a
        class="download-more imgBlock absoluteItem centerX"
        id="more_list"
        v-if="!share_live"
      >
        <img src="../../assets/share/video_shere(5).png" class="imgBlock noevents-img" />
      </a>
      <a class="download-more imgBlock absoluteItem centerX" id="more_list" v-else>
        <img src="../../assets/share/video_share.png" class="imgBlock noevents-img" />
      </a>

      <ul class="flex-box relativeItem" id="u">
        <!--下载图标-->
        <a
          class="download-btn imgBlock centerX"
          :class="{ visible_btn: show_list_btn }"
          id="list-download1"
        >
          <img src="../../assets/share/video_shere.png" class="imgBlock noevents-img" />
        </a>

        <li
          class="relativeItem"
          v-for="(n, index) in list"
          :key="index"
          :style="{ height: live_item_height }"
          v-show="index < 6"
        >
          <a class="allA" @click="play_other(index)"></a>

          <img :src="n.path" class="imgBlock noevents-img cover" v-if="!share_live" />
          <img :src="n.showcover" class="imgBlock noevents-img cover" v-else />
          <!--播放图标-->
          <img
            src="../../assets/share/vshare.png"
            class="play-icon imgBlock noevents-img absoluteItem centerImg"
          />

          <!--小视频类-->
          <div class="b-item video absoluteItem" v-if="!share_live">
            <p class="p1 apostrophe">{{ n.title }}</p>
            <p class="p2">赞{{ n.zancount }} · 评论{{ n.commentcount }}</p>
          </div>

          <!--直播间类-->
          <div class="b-item video absoluteItem" v-else>
            <p class="p1 apostrophe">
              {{ n.showtitle }}
            </p>
            <p class="p3 flex-box">
              <span class="flex-box">
                <img :src="n.network_pointlevel" class="imgBlock noevents-img" />
                {{ n.province }}
              </span>
              <i>{{ n.heat }}</i>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <!--底部下载按钮-->
    <div class="d-bottom">
      <img src="../../assets/share/video_shere(10).png" class="imgBlock noevents-img" />
      <a id="list-download2" class="download-btn absoluteItem centerY">
        <img src="../../assets/share/video_shere(4).png" class="imgBlock noevents-img" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "video_list",
  components: {},
  props: ["list"],
  data() {
    return {
      live_item_height: "236px", //分享直播间页面的列表item高度
      share_live: false, //判断分享出来的是不是直播间
      show_list_btn: false, //是否显示列表中的下载按钮
    };
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              button1 = document.getElementById("list-download1"),
              button2 = document.getElementById("more_list"),
              button3 = document.getElementById("list-download2");
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button1.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
          },
        },
        data
      );
    },

    /**重新加载本页面播放其他视频*/
    play_other(index) {
      let url = window.location.origin + window.location.pathname;
      //判断是视频还是直播间
      if (this.list[index].room_status == 0) {
        //视频
        url += "?live_id=" + this.list[index].photoid;
      } else {
        //判断是电台还是直播间
        url += "?roomnumber=" + this.list[index].roomnumber;
        if (this.list[index].room_status == 1) {
          //直播间
          url += "&share_live=1";
        } else {
          //电台
          url += "&share_bs=1";
        }
      }
      //如果有分享者uid就拼接上
      if (this.$route.query.uid) {
        url += "&uid=" + this.$route.query.uid;
      }

      window.location.href = url;
    },

    /**设置ul的padding-bottom */
    set_p_b() {
      let list = document.querySelector(".list"),
        d_div = document.querySelector(".d-bottom");
      list.style.paddingBottom = d_div.clientHeight * 1.3 + "px";
    },

    /**设置分享直播间的情况下，列表单个元素的宽和高 */
    set_height() {
      this.live_item_height = document.querySelector("#u").clientWidth * 0.49 + "px";
    },

    /**下拉时监听滚动条来显示下载按钮 */
    w_scroll: function () {
      var _this = this;
      // let w_h = window.screen.availHeight; //屏幕高度
      let list = document.querySelector(".list");
      window.onscroll = function () {
        var fall =
          _this.$tool.getScrollHeight() -
          (_this.$tool.getScrollTop() + _this.$tool.getWindowHeight());
        if (fall == 0) {
          //滚动到底部时隐藏按钮
          _this.show_list_btn = false;
        } else if (
          list.offsetTop <
          _this.$tool.getWindowHeight() - _this.$tool.getScrollTop() + 80
        ) {
          _this.show_list_btn = false;
        } else if (!_this.show_list_btn) {
          _this.show_list_btn = true;
        }
      };
    },
  },
  mounted: function () {
    //判断是直播间还是视频
    if (this.$route.query.share_live || this.$route.query.share_bs) {
      this.share_live = true;
      this.set_height();
    }
    let _this = this;
    setTimeout(() => {
      // _this.set_p_b();
      _this.open_install_thing();
      _this.w_scroll();
    }, 1000);
  },
};
</script>

<style scoped>
.allA {
  z-index: 2;
}

/**底部下载按钮 */
.d-bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 4;
  /* position: relative; */
  width: 100%;
}
.d-bottom .download-btn {
  width: 34%;
  right: 0;
}

/**列表 */
.list {
  padding: 12px 8px;
  background: #fff;
}
.title {
  font-size: 15px;
  font-weight: bold;
  background: url("../../assets/share/video_shere(2).png") left center no-repeat;
  background-size: 22px;
  padding-left: 30px;
  margin-bottom: 8px;
}
ul {
  justify-content: space-between;
  flex-wrap: wrap;
}
ul > .download-btn {
  position: fixed;
  bottom: 12%;
  width: 36%;
  z-index: 3;
  visibility: hidden;
  transition: visibility 0.3s;
}
ul > .visible_btn {
  visibility: visible;
}
ul > .download_live_btn {
  width: 36%;
  top: 204px;
  z-index: 3;
}
li {
  width: 49%;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 4px;
}
.download-more {
  width: 100%;
  z-index: 3;
  bottom: 0;
}
.cover {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.play-icon {
  width: 30px;
}
.b-item {
  width: 100%;
  left: 0;
  bottom: 0;
  color: #fff;
  margin-bottom: 8px;
  padding: 0 8px;
}
.video .p1 {
  font-size: 13px;
  margin-bottom: 4px;
}
.video .p2 {
  font-size: 11px;
}
.video .p3 {
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
}
.p3 span {
  align-items: center;
}
.p3 img {
  width: 23px;
  height: 10px;
  margin-right: 4px;
}
.p3 i {
  font-style: normal;
  font-family: kefu;
}
</style>
